import { Lager_Asteria_Bankingconnection } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type BankingConnectionType = Pick<
  Lager_Asteria_Bankingconnection,
  'uid' | 'integration' | 'connection_status' | 'is_onboarded' | 'bank'
>;

export type GetCompanyBankingConnectionQueryType = {
  lager_asteria_bankingconnection: Array<BankingConnectionType>;
};

export type GetCompanyBankingConnectionQueryVariablesType = {
  organizationNumber: string;
  country: string;
};

export const getCompanyBankingConnectionsQuery = gql`
  query getCompanyBankingConnectionsQuery(
    $organizationNumber: String
    $country: String
  ) {
    lager_asteria_bankingconnection(
      where: {
        core_company: {
          country: { _eq: $country }
          orgnr: { _eq: $organizationNumber }
        }
        is_active: { _eq: true }
        is_onboarded: { _eq: true }
      }
    ) {
      uid
      integration
      connection_status
      is_onboarded
      bank
    }
  }
` as TypedDocumentNode<
  GetCompanyBankingConnectionQueryType,
  GetCompanyBankingConnectionQueryVariablesType
>;
